document.querySelectorAll('[data-variant]').forEach((select) => {
  select.addEventListener('change', () => {
    const price = select.closest('[data-product]')?.querySelector('[data-price]');
    if (price) price.textContent = select.selectedOptions[0].dataset.price;
  });
});
document.querySelectorAll('[data-cart-quantity]').forEach((input) => {
  input.addEventListener('input', () => {
    const note = document.querySelector('[data-cart-note]');
    if (note) note.hidden = false;
  });
});
